import alt from 'components/Dispatcher';
import generateAsyncActions from 'utils/generateAsyncActions';
import DashBlacklistSource from 'sources/dashboard/DashBlacklistSource';

class DashBlacklistActions {
  constructor() {
    this.generateActions(...generateAsyncActions('fetchBlacklist'));
  }

  fetchBlacklist({startDate, endDate, teams}) {
    return dispatch => {
      dispatch();
      return DashBlacklistSource.fetchBlacklist({
        startDate,
        endDate,
        teams,
      }).then(this.fetchBlacklistSuccess, this.fetchBlacklistError);
    };
  }
}

export default alt.createActions(DashBlacklistActions);
